export default __webpack_public_path__ + "static/media/testimoni4.8884d97b.webp";